const hexToRgb = (hex) => {
  const clean = String(hex || '').replace('#', '');
  const full = clean.length === 3 ? clean.split('').map((part) => part + part).join('') : clean;
  const value = parseInt(full, 16);
  if (Number.isNaN(value)) return { r: 0, g: 123, b: 255 };
  return { r: (value >> 16) & 255, g: (value >> 8) & 255, b: value & 255 };
};

const luminance = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
};

const pickActionColor = (team) => {
  if (!team) return '#0b6bcb';
  return luminance(team.primary) > 0.72 ? team.secondary : team.primary;
};

const contrastOn = (hex) => (luminance(hex) > 0.62 ? '#111111' : '#ffffff');

export const applyAppearance = ({ theme = 'light', team = null } = {}) => {
  const mode = theme === 'dark' ? 'dark' : 'light';
  const root = document.documentElement;
  root.setAttribute('data-theme', mode);

  try {
    localStorage.setItem('theme', mode);
  } catch (error) {
    // ignore storage failures
  }

  if (!team) {
    root.removeAttribute('data-team-theme');
    ['--team-primary', '--team-secondary', '--team-action', '--team-on-action', '--team-primary-rgb', '--team-secondary-rgb']
      .forEach((name) => root.style.removeProperty(name));
    try {
      localStorage.removeItem('spearheadTeam');
    } catch (error) {
      // ignore
    }
    return;
  }

  const action = pickActionColor(team);
  const primaryRgb = hexToRgb(team.primary);
  const secondaryRgb = hexToRgb(team.secondary);
  root.setAttribute('data-team-theme', 'on');
  root.style.setProperty('--team-primary', team.primary);
  root.style.setProperty('--team-secondary', team.secondary);
  root.style.setProperty('--team-action', action);
  root.style.setProperty('--team-on-action', contrastOn(action));
  root.style.setProperty('--team-primary-rgb', `${primaryRgb.r}, ${primaryRgb.g}, ${primaryRgb.b}`);
  root.style.setProperty('--team-secondary-rgb', `${secondaryRgb.r}, ${secondaryRgb.g}, ${secondaryRgb.b}`);

  try {
    localStorage.setItem('spearheadTeam', JSON.stringify({
      id: team.id,
      name: team.name,
      primary: team.primary,
      secondary: team.secondary,
    }));
  } catch (error) {
    // ignore
  }
};

export const loadStoredAppearance = () => {
  let theme = 'light';
  let team = null;
  try {
    theme = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
    const raw = localStorage.getItem('spearheadTeam');
    if (raw) team = JSON.parse(raw);
  } catch (error) {
    team = null;
  }
  return { theme, team };
};

export const dispatchAppearance = (detail) => {
  window.dispatchEvent(new CustomEvent('appearance-updated', { detail }));
};
